export const SET_TOKEN = 'libras-adm/user/set-token';
export const LOGOUT = 'libras-adm/user/logout';
